<template>
  <button :class="bemClass()">
    <slot></slot>
  </button>
</template>

<script>
import { toRefs } from 'vue'
import useBem from '../../compositions/bem'

export default {
  name: 'SelButton',
  props: {
    modifier: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    const { modifier } = toRefs(props)

    const { bemClass } = useBem('sel-button', modifier)

    return {
      bemClass
    }
  }
}
</script>
<style scoped>
  .sel-button {
    display: inline-flex;
    align-items: center;
    padding: 10px;
    text-align: center;
    cursor: pointer;
    border: 1px solid #000;

    /* reset */
    margin: 0;
    appearance: none;
    background: transparent;

    /* transition */
    transition: color 0.25s, background 0.25s;
  }

  .sel-button:hover {
    background: #000;
    color: #fff;
  }
</style>
